import { PROJECT_CODE } from '../../constants/project';


/**
 * Classes for dialog components.
 *
 * @since 0.1.0
 */
export const CLASS_DIALOG        = `${ PROJECT_CODE }__dialog`;
export const CLASS_DIALOG_GROUP  = `${ CLASS_DIALOG }__group`;
export const CLASS_DIALOG_HEADER = `${ CLASS_DIALOG }__header`;
export const CLASS_DIALOG_TITLE  = `${ CLASS_DIALOG }__title`;
export const CLASS_DIALOG_BODY   = `${ CLASS_DIALOG }__body`;
export const CLASS_DIALOG_FOOTER = `${ CLASS_DIALOG }__footer`;
